'use strict';

angular.module('licensure.services')
    .factory('FBQuestionCriteria', [function () {
        var isNumeric = function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        var escapeString = function (str) {
            var result = "";
            if (str == null) {
                return result;
            }
            result = str.replace(/'/g, "&apos;");
            result = result.replace(/\\/g, "\\\\");
            result = result.replace(/"/g, "&quot;");
            return result;
        }

        return {
            evaluateCondition: function (condition) {
                // Evaluate the condition
                var equation = "";
                var cIndex = 0;
                condition.question_criteria.forEach(function (criterion) {
                    if (cIndex > 0) {
                        if (criterion.and_flag) {
                            equation += ' && ';
                        } else {
                            equation += ' || ';
                        }
                    }

                    for (var i = 0; i < criterion.left_parenthesis; i++) {
                        equation += '(';
                    }

                    if (criterion.question != null) {
                        var answerStatement = '';
                        if (criterion.question.answers == null || criterion.question.answers.length == 0) {
                            //No answers, create one with null value. 
                            //Mostly likely scenario is when the criterion is looking at a conditional question that isn't "enabled"
                            //Work Item 159245, we also see this when the condition is from a question on an form that has not been filled out
                            criterion.question.answers = [];
                            criterion.question.answers.push({ value: null });
                        }
                        var aIndex = 0;

                        // build answers (could be multiple)
                        criterion.question.answers.forEach(function (answer) {
                            var validDate = false;
                            var value = answer.value;
                            var show_value = answer.show_value;

                            if (criterion.value == '@today') {
                                criterion.value = new Date();
                            }

                            if (isValidDate(criterion.value)) {
                                validDate = true;
                                criterion.value = criterion.value.setHours(0, 0, 0, 0);
                            }

                            if (isValidDate(value)) {
                                value = value.setHours(0, 0, 0, 0);
                            }

                            if (value == null && answer.result_set_id != null) {
                                value = answer.result_set_id;
                            }

                            if (aIndex > 0) {
                                answerStatement += ' || ';
                            }

                            //Work Item 159245: the scenario where we are comparing @today to a form question that has not been answered
                            //can end of looking like ('1591851600000'>null)
                            //and since a non-null String value is always greater than a null value
                            //this evaluates to true, resulting in getting a charge based on not filling out a qustion
                            //As a solution, check if the criterion.value is a valid date and the value to compare on is null, return false
                            //This is the most surgical/non-invasive solution at this time
                            if (validDate == true && value == null) {
                                answerStatement = 'false';
                            } else {
                                if (criterion.question.name != null && criterion.value != null && criterion.question.name == "Course" && criterion.operator == 'like' && show_value != null) {

                                    if (show_value.toString().toLowerCase().includes(criterion.value.toString().toLowerCase())) {
                                        answerStatement += 'true';
                                    } else {
                                        answerStatement += 'false';
                                    }
                                } else {
                                    answerStatement += ((criterion.value != null && criterion.value != 'null') ? "'" + escapeString(criterion.value.toString().toLowerCase()) + "'" : 'null');
                                    if (criterion.operator == '=') {
                                        answerStatement += '==';
                                    } else if (criterion.operator == '<>') {
                                        answerStatement += '!=';
                                    } else if (criterion.operator == '>') { // setup field > value.  we are doing value < field.  so need to flip
                                        answerStatement += '<';
                                    } else if (criterion.operator == '<') {
                                        answerStatement += '>';
                                    } else {
                                        answerStatement += criterion.operator;
                                    }
                                    answerStatement += ((value != null && value != 'null') ? "'" + escapeString(value.toString().toLowerCase()) + "'" : 'null');
                                }
                            }

                            // handle comma string answer
                            if (value != null && angular.isString(value) && value.indexOf(',') > 0) {
                                value.split(',').forEach(function (a) {
                                    answerStatement += ' || ';

                                    answerStatement += (criterion.value != null ? "'" + escapeString(criterion.value.toString().toLowerCase()) + "'" : 'null');
                                    if (criterion.operator == '=') {
                                        answerStatement += '==';
                                    } else if (criterion.operator == '<>') {
                                        answerStatement += '!=';
                                    } else if (criterion.operator == '>') { // setup field > value.  we are doing value < field.  so need to flip
                                        answerStatement += '<';
                                    } else if (criterion.operator == '<') {
                                        answerStatement += '>';
                                    } else {
                                        answerStatement += criterion.operator;
                                    }

                                    if (angular.isObject(a)) {
                                        answerStatement += (a != null ? "'" + a.id.toString().toLowerCase() + "'" : 'null');
                                    } else {
                                        answerStatement += (a != null ? "'" + escapeString(a.toString().toLowerCase()) + "'" : 'null');
                                    }
                                })
                            }

                            // check null/empty string
                            if (answerStatement == '') {
                                [null, ''].forEach(function (a, aiIndex) {
                                    if (aIndex > 0 || aiIndex > 0) {
                                        answerStatement += ' || ';
                                    }

                                    answerStatement += (criterion.value != null ? "'" + escapeString(criterion.value.toString().toLowerCase()) + "'" : 'null');
                                    if (criterion.operator == '=') {
                                        answerStatement += '==';
                                    } else if (criterion.operator == '<>') {
                                        answerStatement += '!=';
                                    } else if (criterion.operator == '>') { // setup field > value.  we are doing value < field.  so need to flip
                                        answerStatement += '<';
                                    } else if (criterion.operator == '<') {
                                        answerStatement += '>';
                                    } else {
                                        answerStatement += criterion.operator;
                                    }

                                    answerStatement += (a != null ? "'" + a + "'" : 'null');
                                })
                            }

                            aIndex++;
                        })
                    } else {
                        answerStatement = 'false';
                    }

                    if (answerStatement != '') {
                        equation += '(' + answerStatement + ')';
                    }

                    for (var i = 0; i < criterion.right_parenthesis; i++) {
                        equation += ')';
                    }

                    cIndex++;
                });
                if (equation.indexOf(" && ") == 0) {
                    equation = equation.replace(" && ", "");
                }
                if (equation.indexOf(" || ") == 0) {
                    equation = equation.replace(" || ", "");
                }

                try {
                    var result = equation != '' && eval(equation);
                    return result;
                } catch (e) {
                    console.log(e);
                    return null;
                }
            }
        }
    }])
    ;